import { Typography, TypographyProps } from '@mui/material'
import { TOptions } from 'i18next'
import { useTranslation } from 'react-i18next'
import { useLocalizationKey } from './useLocalizationKey'
import React, { useMemo } from 'react'

type Props = TypographyProps<'span' | 'p' | 'h5' | 'h6' | 'a'> & {
  translationKey: string
  translationDefaultValue?: string
  options?: TOptions
  ns?: string[]
  component?: string
  children?: string
  suffix?: string
  html?: boolean
  href?: string
}

const LocalizedTypographyComp = (props: Props) => {
  const {
    translationKey,
    ns,
    translationDefaultValue: defaultValue,
    options,
    suffix,
    children,
    prefix,
    html,
    ...typographyProps
  } = props

  const { namespace, tKey } = useLocalizationKey(translationKey, ns?.[0])

  const { t } = useTranslation(namespace)

  const variant = typographyProps.variant || 'inherit'

  if (html) {
    return (
      <Typography
        component={props.component || 'span'}
        dangerouslySetInnerHTML={{
          __html: t(translationKey, options as any).toString(),
        }}
        {...typographyProps}
        variant={variant}
      />
    )
  } else {
    return (
      <Typography component={props.component || 'span'} {...typographyProps}>
        {`${prefix || ''}${t(
          tKey,
          (options ?? { defaultValue: children ?? defaultValue }) as any
        )}${suffix ?? ''}`}
      </Typography>
    )
  }
}

export const LocalizedTypography = React.memo(LocalizedTypographyComp, (prevProps, nextProps) => {
  return (
    prevProps.translationKey === nextProps.translationKey
  )
})

